import { Component, OnInit, OnDestroy, TemplateRef, Input, SimpleChanges, KeyValueDiffer, KeyValueDiffers, IterableDiffers, OnChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription, Observable, Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

import { SET_BATCH_LIST_VIEW } from '../../../../ngrx/actions';
import { OA } from '../../../../ngrx/category-types';
import { COMPLETED, CUT, DIE, LOCKED, QUEUED, MATERIAL, NO_BATCHES, OPEN, QTY, SCRAP, DIENOTAVAILABLE, MATERIALNOTAVAILABLE, ONLASER, SEALED, HOLD } from '../../../../ngrx/status-types';
import { HORIZONCOLORMAPS } from '../../../../ngrx/job-locations';
import { Batch, Die, Horizon, Job, Scrap } from '../../../models';

import { 
  AuthenticationService,
  BatchService,
  HorizonService,
  JobService,
  OrderService,
  PrinterService,
  ScannerService,
  ScrapService,
  SettingService,
  ProductService
} from '../../../services';

import { TranslateService } from '../../../i18n';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { SCRAPREASONSMAPPING, SCRAPREASONS, LASER_LIST } from 'ngrx/scrap-reasons';

@Component({
  templateUrl: 'wizard-modal.component.html',
  styleUrls:   ['wizard-modal.component.scss']
})
export class WizardModal implements OnInit, OnDestroy {
  @Input('batches')      batches;
  @Input('horizon')      horizon;
  empDifferMap = new Map<number, any>();
  empMap = new Map<number, any>();
  arrayDiffer: any;


  mtsWorkOrderModalRef     : BsModalRef;
  onHoldModalRef           : BsModalRef;
  onHoldModalSingleJobRef  : BsModalRef;
  availableHorizons        : Horizon[];
  batchCuttingModalRef     : BsModalRef;
  currentJobID             : string;
  cuttingView              : string;
  currentBatch             : Batch;
  currentDie               : Die;
  currentJob               : Job;
  currentPressureSetting   : any;
  dieList                  : Observable<Die[]>;
  diePressureForm          : FormGroup;
  diePressureUpdating      : boolean;
  loading                  : boolean;
  batchListView            : Observable<any>;
  filteredBatches          : Batch[];
  holdReason               : string;
  otherReason              : string;
  singleJobHoldReason      : string;
  comment                  : string;
  horizonName              : string;
  horizons                 : any[][];
  horizonBatches           : Batch[][];
  horizonFilter            : string;
  horizonHeaders           : any;
  horizonList              : Observable<Horizon[]>;
  initialPressureValue     : number;
  invalidDieScan           : string;
  invalidMaterialScan      : string;
  mtsWorkOrdersPrinting    : boolean;
  newDiePressureValue      : number;
  nextBatch                : Batch;
  nextBusinessDay          : Observable<string>;
  nextJob                  : Job;
  nextTotalQty             : number;
  openBatches              : Batch[];
  packagingImageURL        : string;
  previousPackagingImageURL: string;
  previousBatch            : Batch;
  previousJob              : Job;
  qtyRemaining             : number;
  queuedMTSJobs            : Observable<Job[]>;
  scrapForm                : FormGroup;
  scrapLoading             : boolean;
  sortedBatchList          : Observable<any>;
  sortedOABatches          : any;
  switchingBatch           : boolean;
  totalQty                 : number;
  previousSubAssemblyID    : string;
  subAssemblyID            : string;
  jobList                  : Observable<Job[]>;
  mainView                 : Observable<any>;
  batchCuttingSubscriptions: Subscription[];
  initSubscriptions        : Subscription[];
  syncBatchAndJob          : Subject<any>;
  dieLoading               : boolean;
  materialLoading          : boolean;

  wizBatches       : any;
  curBatchOrder    : any;
  currentBatchJobs : any = [];
  nextBatchJobs    : any = [];
  objBatchDiffer   : any;
  objBatchJobDiffer: any;
  differ           : any;
  curBatchTotalQty : any;
  curBatchQtyLeft  : any;
  nextBatchTotalQty: any;
  scrapReasonsList : any;
  machine          : any;
  lasersList       : string[] = LASER_LIST;
  scannedMaterialObj : any = {};
  scannedDieObj      : any = {};
  isCuttingError: boolean = false;
  constructor(
    private authService   : AuthenticationService,
    private batchService  : BatchService,
    private fb            : FormBuilder,
    private horizonService: HorizonService,
    private jobService    : JobService,
    private modalService  : BsModalService,
    private printerService: PrinterService,
    private productService: ProductService,
    private orderService  : OrderService,
    private route         : ActivatedRoute,
    private router        : Router,
    private scanner       : ScannerService,
    private scrapService  : ScrapService,
    private settingService: SettingService,
    private store         : Store<any>,
    private translate     : TranslateService,
    private differs       : KeyValueDiffers
  ) {
    this.batchListView   = this.batchService.getBatchListView();
    this.dieList         = this.batchService.getDieList();
    this.jobList         = this.jobService.getJobList();
    this.horizonList     = this.horizonService.getHorizonList();
    this.mainView        = this.authService.getMainView();
    this.nextBusinessDay = this.settingService.getNextBusinessDay();
    this.queuedMTSJobs   = this.jobService.getQueuedMTSJobList();
    this.sortedBatchList = this.batchService.getSortedOABatchList();
  }

  ngOnInit(): void {
    this.batchListView
    .subscribe(batchListViewState => {
      const { 
        cuttingView, 
        diePressureUpdating,
        invalidDieScan, 
        invalidMaterialScan,
        loading, 
        mtsWorkOrdersPrinting,
        scrapLoading,
        switchingBatch,
        dieLoading,
        materialLoading
      } = batchListViewState;
      this.cuttingView         = cuttingView;
      this.diePressureUpdating = diePressureUpdating;
      this.invalidDieScan      = invalidDieScan;
      this.invalidMaterialScan = invalidMaterialScan;
      this.loading             = loading;
      this.mtsWorkOrdersPrinting = mtsWorkOrdersPrinting;
      this.scrapLoading        = scrapLoading;
      this.switchingBatch      = switchingBatch;
      this.dieLoading          = dieLoading;
      this.materialLoading     = materialLoading;
    });
    this.machine = JSON.parse(localStorage.getItem('horizonConfig'));
    if(this.machine) {
      if(this.machine.type.toLowerCase() === 'laser') {
        this.scrapReasonsList = SCRAPREASONS.filter(reason => {
          return reason.location.toLowerCase() != 'horizon'
        })
      } else if(this.machine.type.toLowerCase() === 'horizon') {
        this.scrapReasonsList = SCRAPREASONS.filter(reason => {
          return reason.location.toLowerCase() != 'sei laser'
        })
      }
    }
    this.lasersList = LASER_LIST;
    this.createForms();
    this.syncBatchAndJob = new Subject();
    
    this.wizBatches = this.batches[this.horizon.id];
    this.curBatchOrder = this.wizBatches;
    console.log("this.wizBatches : ", this.wizBatches);
    console.log("this.curBatchOrder : ", this.curBatchOrder);
    console.log("this.cuttingView : ", this.cuttingView);

    // checks length
    this.differ = this.differs.find(this.wizBatches).create();
    // checks values
    this.objBatchDiffer = {};

    // Jobs Differ - currently not used but could be needed in future
    // this.objBatchJobDiffer = {};

    this.wizBatches.forEach((elt) => {
      this.objBatchDiffer[elt.id] = this.differs.find(elt).create();
    });


    if(this.curBatchOrder.length === 0) {
      this.store.dispatch({
        type: SET_BATCH_LIST_VIEW,
        payload: { cuttingView: NO_BATCHES }
      });
    } else {
      this.currentBatch = this.curBatchOrder[0];
      this.nextBatch = this.curBatchOrder[1] || null;
      console.log("this.curBatch: ", this.currentBatch);
      this.updateCurrentBatch();
    }

    this.initSubscriptions = [
      Observable  
        .combineLatest(
          this.dieList
        )
        .subscribe(([ dies  ]) => {
            this.diePressureForm.patchValue({
              adjustDiePressure: false
            });

            this.diePressureForm.markAsPristine();

            if(this.currentBatch) {
              this.currentDie = dies.find(die => die.id === this.currentBatch.die);

            if (this.currentDie && this.currentDie.die_pressures) {
              const associatedPressures = [ ...this.currentDie.die_pressures ];

                if (associatedPressures.length) {
                  const associatedPressure = associatedPressures.find(die => die.subAssemblyID === this.currentBatch.subAssembly);
                  
                  if ((associatedPressure && !this.currentPressureSetting) || (associatedPressure && this.currentPressureSetting && (associatedPressure.currentPressure !== this.currentPressureSetting.currentPressure || associatedPressure.currentPressure !== this.currentPressureSetting.defaultPressure))) {
                    this.currentPressureSetting = associatedPressure;
    
                    this.initialPressureValue = this.currentPressureSetting.currentPressure !== this.currentPressureSetting.defaultPressure 
                      ? this.currentPressureSetting.currentPressure 
                      : this.currentPressureSetting.defaultPressure;
    
                    if (this.currentPressureSetting) {
                      this.diePressureForm.patchValue({
                        diePressureValue: this.initialPressureValue
                      });
                    }
                  }
                }
              }
            }
          
        }),

        
      this.sortedBatchList
        .subscribe((batchesByHorizon)=>{
          const batches = batchesByHorizon[this.horizon.id];
          this.wizBatches = batches;
          if (!batches || !batches.length) {
            console.log("NO BATCHES");
            // this.cuttingView = NO_BATCHES;
            this.store.dispatch({
              type: SET_BATCH_LIST_VIEW,
              payload: { cuttingView: NO_BATCHES }
            });
            this.curBatchOrder = [];
            // this.objBatchJobDiffer = {};
            this.objBatchDiffer = {};
            this.currentBatch = null;
            this.nextBatch = null;
          } else {
            console.log("BATCHES");
            let batchRemoved = Object.keys(this.objBatchDiffer).length > this.wizBatches.length;
            let batchAdded   = Object.keys(this.objBatchDiffer).length < this.wizBatches.length;

            // BATCH COMPLETED AND SCRAP ENTERED
            // REMOVED FROM LIST
            if(batchRemoved) {
              console.log("BATCH REMOVED");
              // Either removed because completed or removed manually

              let set = new Set();
              this.wizBatches.forEach((b)=> {
                set.add(b.id);
              })
              // console.log(set)
              for(let key in this.objBatchDiffer) {
                if(!set.has(key)) {
                  let removedBatch = this.objBatchDiffer[key];
                  delete this.objBatchDiffer[key];
                  let indexOf = this.curBatchOrder.findIndex((b)=> b.id === key);
                  this.curBatchOrder.splice(indexOf, 1);
                  // console.log(this.curBatchOrder);
                  // console.log(indexOf);

                  // if removed batch is the one that is being worked on
                  if(key === this.currentBatch.id) {
                    this.currentBatch = this.nextBatch;
                    this.nextBatch    = this.curBatchOrder.length > 1 ? this.curBatchOrder[1] : null;
                    this.updateCurrentBatch();
                    this.store.dispatch({
                      type: SET_BATCH_LIST_VIEW,
                      payload: { loading: false }
                    });

                    //go back to material view to scan new material if new material is detected
                    removedBatch.forEachItem((attr) => {
                      if(attr.key === 'subAssembly' && (attr.currentValue != this.currentBatch.subAssembly)){
                        console.log('SUBASSEMBLY MISMATCH')
                        this.store.dispatch({
                          type: SET_BATCH_LIST_VIEW,
                          payload: { cuttingView : QTY }
                        });
                      }
                    })
                  }
                  if(this.nextBatch && key === this.nextBatch.id) {
                    this.nextBatch    = this.curBatchOrder.length > 1 ? this.curBatchOrder[1] : null;
                    this.getJobsInBatch(this.nextBatch, 'nextBatch');
                  }

                }
              }
            } else if(batchAdded) {
              this.wizBatches.forEach((b)=> {
                if(!this.objBatchDiffer.hasOwnProperty(b.id)) {
                  this.objBatchDiffer[b.id] = this.differs.find(b).create();
                  this.curBatchOrder.push(b);
                }
              })
              console.log(this.currentBatch)
              if(this.currentBatch == null) {
                this.currentBatch = this.curBatchOrder[0];
                this.updateCurrentBatch()
                this.store.dispatch({
                  type: SET_BATCH_LIST_VIEW,
                  payload: { 
                    cuttingView : QTY
                  }
                });
              }
              if(this.nextBatch == null && this.curBatchOrder.length > 1) {
                this.nextBatch = this.curBatchOrder[1];
                
              }
              console.log("new Batch Added to back of the curBatchOrder ", this.curBatchOrder);
            }           
        
            for (let batch of this.wizBatches) {
              let prevBatch = this.objBatchDiffer[batch.id];
              // console.log("preve batcch : ", prevBatch)
              if(prevBatch) {
                let changes = prevBatch.diff(batch);
                if (changes) {
                  let recordChanged = false;
                  changes.forEachChangedItem(record => {
                    recordChanged = true;
                    console.log("BATCH UPDATED");
                    //console.log(record.key);
                    if(this.currentBatch && batch.id && this.currentBatch.id === batch.id) {
                      //console.log('this.currentBatch', this.currentBatch)
                      //console.log('batch', batch)
                      //console.log('record', record)
                      if(record.key === 'batchStatus' && (record.previousValue === LOCKED && record.currentValue === COMPLETED)) {
                        if(!this.currentBatch.designatedScrap) {
                          this.createForms()
                          this.store.dispatch({
                            type: SET_BATCH_LIST_VIEW,
                            payload: { 
                              loading: false, 
                              cuttingView: SCRAP 
                            }
                          });
                        } 
                      }
                      // if(record.key === 'numberOfJobs' && (record.previousValue > record.currentValue) && record.currentValue > 0) {
                      //   // this.currentJob = 
                      // }
                      if(record.key === 'jobs' && record.currentValue != null && (record.currentValue[0].jobsList && record.currentValue[0].jobsList.length > 0)) {
                        this.store.dispatch({
                          type   : SET_BATCH_LIST_VIEW,
                          payload: { loading: false }
                        });
                        this.getJobsInBatch(this.currentBatch, 'curBatch', false);

                        this.currentBatchJobs  = this.currentBatchJobs && this.currentBatchJobs.filter(job => job.status == QUEUED);
                        console.log(this.currentBatchJobs);
                        this.currentJob   = this.currentBatchJobs[0];
                        console.log("CURRENT JOB: ", this.currentJob)
                
                
                        this.packagingImageURL = this.currentJob ? `https://img.avery.com/x_340,y_5,w_2320,h_3000,c_crop/w_304,h_406,c_scale/web/blank-labels/packaging/${this.currentJob.oaDetails.template.code}` : '';
                        if(this.currentJob){
                          console.log(`printing work order for Job ${this.currentJob.id}`);
                          // this.printerService.printWorkOrder(this.currentJob, this.currentJob.reprint);
                          // this.printerService.printWorkOrder(this.currentJob, false);
                        }
                      }
                      
                    }

                    //Turn off loader when new die is detected
                    if(this.currentBatch && batch.die && this.currentBatch.die === batch.die){
                      this.store.dispatch({
                        type: SET_BATCH_LIST_VIEW,
                        payload: { 
                          dieLoading: false 
                        }
                      });
                    }
                    
                    //Turn off loader when new material is detected
                    if (this.currentBatch && batch.subAssembly && this.currentBatch.subAssembly === batch.subAssembly){
                      this.store.dispatch({
                        type: SET_BATCH_LIST_VIEW,
                        payload: { 
                          materialLoading: false 
                        }
                      });
                    }
                  });
                }
              } 
            }
          }
        }),
        // job subscription - currently not used - but might be needed in the future
      // this.jobList
      //   .subscribe((jobs) => {
      //     // console.log("UPDATED JOBS",jobs)
      //     for(let key in this.objBatchJobDiffer) {
      //       let curJob = jobs.find((j) => j.id === key);
      //       // console.log(this.objBatchJobDiffer)
      //       let prevJob = this.objBatchJobDiffer[key];
      //       if(prevJob) {
      //         let changes = prevJob.diff(curJob);
      //         if (changes) {
      //           changes.forEachChangedItem(record => {
      //             console.log(record);
      //             console.log("Job CHANGED");
      //             console.log(record.key);
      //             console.log('Previous value: ' + record.previousValue);
      //             console.log('Current value: ' + record.currentValue);
      //           });
      //         }
      //       }
      //     }
      //   }),

      this.diePressureForm
        .get('adjustDiePressure')
        .valueChanges
        .subscribe(value => {
          if (!value) {
            this.diePressureForm.patchValue({
              diePressureValue: this.initialPressureValue
            });

            this.diePressureForm.markAsPristine();
            this.diePressureForm.markAsUntouched();
          }
        }),

      this.scanner
        ._batchCuttingListener
        .subscribe(id => {
          console.log(`ID ${id} scanned`);
          if (this.currentBatch && this.currentJob) {
            if (this.cuttingView === QTY) {
              if (id === this.currentJob.oaDetails.material.subassembly_part_number) {
                this.scannedMaterialObj = {
                  scannedMaterial: id,
                  user: this.authService.getCurrentUser(),
                }
                console.log(`Valid material ID provided`);
                if (this.previousBatch && this.currentBatch.die === this.previousBatch.die) {
                  this.store.dispatch({
                    type   : SET_BATCH_LIST_VIEW,
                    payload: { 
                      cuttingView        : MATERIAL,
                      invalidMaterialScan: ''
                    }
                  });
                } else {

                  if( this.currentBatch && this.currentBatch.die && 
                    (this.currentBatch.die.includes('95282') || this.currentBatch.die.includes('94268') || this.currentBatch.die.includes('94269'))){
                    //Skip die cutting for dies 95282 and 94268 since no cutting is required
                    this.store.dispatch({
                      type   : SET_BATCH_LIST_VIEW,
                      payload: { 
                        cuttingView        : MATERIAL,
                        invalidMaterialScan: ''
                      }
                    });
                    // this.printerService.printWorkOrder(this.currentJob, this.currentJob.reprint);
                    // this.printerService.printWorkOrder(this.currentJob, false);
                  }else{
                    if(this.machine && this.machine.type && this.machine.type.toLowerCase() === 'laser'){
                      // this.printerService.printWorkOrder(this.currentJob, false);
                      this.store.dispatch({
                        type   : SET_BATCH_LIST_VIEW,
                        payload: { 
                          cuttingView        : MATERIAL,
                          invalidMaterialScan: ''
                        }
                      });
                    }else{
                      this.store.dispatch({
                        type   : SET_BATCH_LIST_VIEW,
                        payload: { 
                          cuttingView        : DIE,
                          invalidMaterialScan: ''
                        }
                      });
                    }

                  }

                }
              } else {
                console.log(`Invalid material ID provided`);
                this.store.dispatch({
                  type   : SET_BATCH_LIST_VIEW,
                  payload: { 
                    invalidMaterialScan: this.translate.instant(
                      'INVALID_MATERIAL_ID_SCAN', 
                      [id, this.currentJob.oaDetails.material.subassembly_part_number]
                    ) 
                  }
                });
              }
            } else if (this.cuttingView === DIE) {
              const expectedDieCode = this.currentJob.oaDetails.die.code;
              // For PTO jobs, strip suffix and compare first 5 digits
              // Capture the first 5 starting digits and disregard any suffix like -01, -02, -03, etc.
              const isPTOJob = !!(this.currentJob && this.currentJob.oaDetails && this.currentJob.oaDetails.pto);
              const scannedBaseForPTO = (() => {
                if (!id) return id;
                const match = String(id).match(/^(\d{5})/);
                return match ? match[1] : id;
              })();
              const isValidScan = isPTOJob
                ? (scannedBaseForPTO === expectedDieCode)
                : (id === expectedDieCode || id === '94268-01' || id === '94268-02');

              if (isValidScan) {
                console.log(`Valid die ID provided`);
                this.scannedDieObj = {
                  scannedDie: id,
                  user: this.authService.getCurrentUser(),
                }
                this.store.dispatch({
                  type   : SET_BATCH_LIST_VIEW,
                  payload: { 
                    cuttingView   : MATERIAL,
                    invalidDieScan: ''
                  }
                });

                // this.printerService.printWorkOrder(this.currentJob, this.currentJob.reprint);
                // this.printerService.printWorkOrder(this.currentJob, false);
              } else {
                console.log(`Invalid die ID provided`);
                this.store.dispatch({
                  type   : SET_BATCH_LIST_VIEW,
                  payload: {
                    invalidDieScan: this.translate.instant(
                      'INVALID_DIE_ID_SCAN',
                      [id, expectedDieCode]
                    )
                  }
                })
              }
            }
          }
        })
    ];  
  }
  bypass() {
    this.store.dispatch({
      type   : SET_BATCH_LIST_VIEW,
      payload: { 
        cuttingView   : MATERIAL,
        invalidDieScan: ''
      }
    });
  }
  
  ngDoCheck() {
    // console.log(this.wizBatches)

  }

  ngOnDestroy(): void {
    console.log("Destroying...")
    // this.batch.unsubscribe();
    this.initSubscriptions.forEach(subscription => subscription.unsubscribe());
    // !!this.batchCuttingSubscriptions && this.batchCuttingSubscriptions.forEach(subscription => subscription.unsubscribe());
    // !!this.batchCuttingModalRef && this.batchCuttingModalRef.hide();

    if (this.currentBatch && this.currentBatch.batchStatus === LOCKED) {
      const unlockedBatch = Object.assign({}, this.currentBatch, {
        batchStatus: SEALED
      });

      this.batchService.updateBatch(unlockedBatch);
    }
  }

  updateCurrentBatch(): void {
    this.getJobsInBatch(this.currentBatch, 'curBatch', true);
    //console.log('currentBatchJobs',this.currentBatchJobs)
    this.getJobsInBatch(this.nextBatch, 'nextBatch');
     //console.log('nextBatchJobs',this.nextBatchJobs);

    this.currentBatchJobs  = this.currentBatchJobs && this.currentBatchJobs.filter(job => job.status == QUEUED);
    // console.log('FILTER currentBatchJobs',this.currentBatchJobs);

    this.objBatchJobDiffer = {};
    this.currentBatchJobs.forEach((elt) => {
      this.objBatchJobDiffer[elt.id] = this.differs.find(elt).create();
    });

    // let jobsInNextBatchReadyToPrint = this.nextBatchJobs && this.nextBatchJobs.filter(job => job.status == QUEUED);
    if((!this.currentBatchJobs || this.currentBatchJobs.length == 0) && (this.currentBatch && this.currentBatch.batchStatus === COMPLETED)){
      console.log("cutting view : scrap")
      // if(!this.currentBatch.designatedScrap) {
      this.store.dispatch({
        type: SET_BATCH_LIST_VIEW,
        payload: { cuttingView: SCRAP }
      });
      // }
      // const job = jobs.find(job => job.id === this.currentBatch.jobHistory[0]);
      // this.previousPackagingImageURL = job ? `https://img.avery.com/x_340,y_5,w_2320,h_3000,c_crop/w_304,h_406,c_scale/web/blank-labels/packaging/${job.oaDetails.template.image_code && job.oaDetails.template.is_custom_size !='1' ? job.oaDetails.template.image_code : job.oaDetails.template.code }` : '';

    } else if (this.currentBatchJobs.length > 0 && (this.currentBatch.batchStatus === OPEN || this.currentBatch.batchStatus === LOCKED || this.currentBatch.batchStatus === ONLASER || this.currentBatch.batchStatus === SEALED)) {
      console.log(`new batch selected, locking it now`);

      if(this.currentBatchJobs.length == 0){
        const completedBatch = Object.assign({}, this.currentBatch, {
          batchStatus: COMPLETED
        });
        this.batchService.updateBatch(completedBatch);
      } else {
        // const lockedBatch = Object.assign({}, this.currentBatch, {
        //   batchStatus: LOCKED
        // });
        // this.batchService.updateBatch(lockedBatch);

        // REMOVE JOBS THAT ARE NOT ACTIVE
        var jobsList = this.currentBatch.jobs[0].jobsList;
        var removeList = [];
        jobsList.forEach(batchedJob => {
          const activeBatchedJobArray = this.currentBatchJobs.filter(job => job.id == batchedJob.jobId);
          if(!activeBatchedJobArray || activeBatchedJobArray.length == 0){
            removeList.push(batchedJob.jobId);
          }
        });
        jobsList = jobsList.filter(job => removeList.indexOf(job.jobId) < 0);
        // console.log("JOBS LIST: ", jobsList)

        // recalculate total qty and due date
        var totalQuantity = 0;
        var dueDate = this.currentBatchJobs[0].dueDate;
        this.currentBatchJobs.forEach(job => {
          if(moment(job.dueDate).isBefore(moment(dueDate))){
            dueDate = job.dueDate;
          }
          if(job.reprint){
            totalQuantity += job.numPages;
          } else {
            totalQuantity += job.qty;
          }
        });
        const jobs = [
          {
            subAssemblyID:this.currentBatch.jobs[0].subAssemblyID,
            jobsList: jobsList
          }
        ];

        // console.log(`upcoming jobs`);
        // console.log(this.currentBatchJobs);

        this.currentJob   = this.currentBatchJobs[0];
        //console.log("CURRENT JOB: ", this.currentJob)


        this.packagingImageURL = this.currentJob ? `https://img.avery.com/x_340,y_5,w_2320,h_3000,c_crop/w_304,h_406,c_scale/web/blank-labels/packaging/${this.currentJob.oaDetails.template.code}` : '';
        // console.log(`printing work order for Job ${this.currentJob.id}`);
        // this.printerService.printWorkOrder(this.currentJob, this.currentJob.reprint);

        
        if(this.currentBatch.batchStatus != LOCKED) {
          this.currentBatch.batchStatus = LOCKED;
        }
        const updatedBatch = Object.assign({}, this.currentBatch, {
          jobs: jobs,
          totalQty: totalQuantity,
          dueDate: dueDate,
          numberOfJobs: jobsList.length
        });
        this.batchService.updateBatch(updatedBatch);

      }
    }
  }

  cancelCutting(): void {
    this.modalService.hide(1);
    // !!this.batchCuttingModalRef && this.batchCuttingModalRef.hide();

    // this.sortedBatchList
    //   .take(1)
    //   .subscribe(
    //     batchesByHorizon => {
    //       if (this.currentBatch) {
    //         const stateBatch = batchesByHorizon[this.horizon.id] && batchesByHorizon[this.horizon.id].find(batch => batch.id === this.currentBatch.id && batch.batchStatus === LOCKED);

    //         if (stateBatch) {
    //           const unlockedBatch = Object.assign({}, this.currentBatch, {
    //             batchStatus: OPEN
    //           });
          
    //           this.batchService.updateBatch(unlockedBatch);
    //         }
    //       }
    //     },
    //     () => {},
    //     () => {
    //       this.store.dispatch({
    //         type   : SET_BATCH_LIST_VIEW,
    //         payload: { cuttingView: '' }
    //       });
          
    //       this.batchCuttingSubscriptions.forEach(subscription => subscription.unsubscribe());

    //       this.currentBatch = null;
    //       this.currentJob = null;
    //       this.previousJob = null;
    //       this.previousBatch = null;
    //       this.nextBatch = null;
    //       this.nextJob = null;
    //       this.syncBatchAndJob.next({ 
    //         batch        : null,
    //         jobID        : null,
    //         subAssemblyID: null
    //       });

    //       this.diePressureForm.patchValue({
    //         adjustDiePressure: false
    //       });

    //       this.diePressureForm.markAsPristine();
    //     }
    //   );
  }

  clearError(): void {
    this.store.dispatch({
      type   : SET_BATCH_LIST_VIEW,
      payload: {
        invalidDieScan     : '',
        invalidMaterialScan: ''
      }
    });
  }

  async continueCutting(): Promise<void> {
    console.log("this.scrapForm.value", this.scrapForm.value);
    console.log("this.scrapForm", this.scrapForm);

    if (this.cuttingView === SCRAP) {
      this.isCuttingError = false;
      if (this.scrapForm.valid) {
        this.createScrapEntry();
      }
    } else if (this.cuttingView === QTY) {
      /**
       * After loading X amount of sheets for a particular material, check the
       *    die id. Prompt the operator to check the die and whether or not it's
       *    already loaded into the Horizon
       */
      if (this.previousBatch && this.currentBatch.die === this.previousBatch.die) {
        this.store.dispatch({
          type   : SET_BATCH_LIST_VIEW,
          payload: { 
            cuttingView        : MATERIAL,
            invalidMaterialScan: ''
          }
        });
      } else {
        this.store.dispatch({
          type   : SET_BATCH_LIST_VIEW,
          payload: { 
            cuttingView        : DIE,
            invalidMaterialScan: ''
          }
        });
      }
    } else if (this.cuttingView === DIE) {
      /**
       * After the die is loaded, prompt operator to begin printing material
       *    for each individual qty in the batch
       */
       this.store.dispatch({
         type   : SET_BATCH_LIST_VIEW,
         payload: { cuttingView: MATERIAL }
       });

    } else if (this.cuttingView === MATERIAL) {
      /**
       * If the batch still has jobs to print, continue printing
       * And send that job to CUT, removing from batch
       */
      if (this.currentBatch.numberOfJobs) {
        console.log("THIS CURRENT BATCH AFTER JOB IS CUT : ", this.currentBatch);
        this.store.dispatch({
          type   : SET_BATCH_LIST_VIEW,
          payload: { loading: true }
        });

        let batchIdHistory = [];
        if(this.currentJob.batchIdHistory) {
          if(this.currentJob.batchId && this.currentJob.batchIdHistory.indexOf(this.currentJob.batchId) === -1) {
            batchIdHistory = [this.currentJob.batchId, ...this.currentJob.batchIdHistory];
          }
        } else {
          batchIdHistory = [this.currentJob.batchId];
        }

        const timestamp  = new Date().getTime();
        const user       = JSON.parse(localStorage.getItem('currentUser'))['email'];
        // console.log("this.scannedMaterialObj", this.scannedMaterialObj);
        // console.log("this.scannedDieObj", this.scannedDieObj);
        const updatedJob = Object.assign({}, this.currentJob, {
          activity_history: [
            {
              activity: CUT,
              note    : 'Job status updated',
              timestamp: `${timestamp}`,
              user
            },  
            ...this.currentJob.activity_history
          ],
          status         : CUT,
          previous_status: QUEUED,
          designateScrap : false,
          batchId: null, // batchId needs to be cleared as well.
          batchIdHistory: batchIdHistory,
          horizonId: this.currentBatch.horizon_id // horizonId is set on status update to CUT, it will be easy to filter the jobs based on horizon.
        });

      if(this.scannedMaterialObj && Object.keys(this.scannedMaterialObj).length > 0 && this.scannedMaterialObj.scannedMaterial){
          updatedJob.activity_history.unshift({
          activity: 'Material Scanned',
          note    :  `${this.scannedMaterialObj.scannedMaterial}`,
          timestamp: `${timestamp}`,
          user: this.scannedMaterialObj.user
         });
        }
      if(this.scannedDieObj && Object.keys(this.scannedDieObj).length > 0 && this.scannedDieObj.scannedDie){
        updatedJob.activity_history.unshift({
          activity: 'Die Scanned',
          note    : `${this.scannedDieObj.scannedDie}`,
          timestamp: `${timestamp}`,
          user: this.scannedDieObj.user
        });
      }

        console.log(`Pushing job into CUT`);
        console.log(updatedJob);

        // try {
        //   // Wait for job update to complete before printing work order
        //   await this.orderService.updateJobAsync(updatedJob);
        //   console.log('Job successfully updated to CUT status');
          
        //   // Only print work order after successful job update
        //   if (this.currentJob) {
        //     console.log("PRINTING WORK ORDER AFTER SUCCESSFUL JOB UPDATE: ", this.currentJob);
        //     this.printerService.printWorkOrder(this.currentJob, this.currentJob.reprint || false);
        //   }
          
        // } catch (error) {
        //   console.error('Failed to update job to CUT status:', error);
        // }

        try {
          // Wait for job update to complete before printing work order
          await this.orderService.updateJobAsync(updatedJob).then(async () => {
            console.log('Job successfully updated to CUT status');
            this.isCuttingError = false;
            if (this.scannedDieObj && Object.keys(this.scannedDieObj).length > 0 && this.scannedDieObj.scannedDie) {
              this.batchService.appendDieScanHistoryAsync(
                this.scannedDieObj.scannedDie,
                this.scannedDieObj.user || user,
                `${timestamp}`,
                this.currentJob ? this.currentJob.orderId : undefined,
                this.currentJob ? this.currentJob.id : undefined
              ).catch((err) => console.warn('Die scan history update failed:', err));
            }
            // Only print work order after successful job update
            if (this.currentJob) {
              console.log("PRINTING WORK ORDER AFTER SUCCESSFUL JOB UPDATE: ", this.currentJob);
              this.printerService.printWorkOrder(this.currentJob, this.currentJob.reprint || false);
            }
          }).catch((error) => {
            console.error('Failed to update job to CUT status:', error);
            this.isCuttingError = true;
            this.store.dispatch({
              type   : SET_BATCH_LIST_VIEW,
              payload: { 
                cuttingView        : MATERIAL,
                loading: false
              }
            });
          });
          
          
        } catch (error) {
          console.error('Failed to update job to CUT status:', error);
        }
      }
    }
  }

  createForms(): void {
    let getInitLocValue = () => {
      if (this.machine && this.machine.type !== 'laser') {
        return Object.assign({}, {
          value: this.machine.name,
          disabled: true
        });
      }
      return null;
    }
    let defaultMachine = getInitLocValue();
    this.diePressureForm = this.fb.group({
      adjustDiePressure: [false, Validators.required],
      diePressureValue : [null, [Validators.required, Validators.max(20), Validators.min(-20), this.pressureStepValidator.bind(this)]]
    });

    this.scrapForm = this.fb.group({
      scrapReasons: this.fb.array([
        this.fb.group({
          reason  : [null, [Validators.required]],
          quantity: [0, [Validators.required, Validators.min(1), Validators.max(999)]],
          other_comment: [null]
        })
      ]),
      location: [defaultMachine, [Validators.required]]
    });
  }

  createScrapEntry(): void {  
    console.log(this.scrapForm.get('location').value);
    if (this.scrapForm.valid) {
      console.log(`creating scrap entry for batch ${this.currentBatch.increment_id}`);
      const { scrapReasons } = this.scrapForm.value;
      let scrapCodes = scrapReasons.map(scrap => {
        let scrapVal = Object.assign({},
          SCRAPREASONSMAPPING[scrap.reason],
          { "location": this.scrapForm.get('location').value } // Be more specific on which machine
        )
        scrapVal.other_comment = scrap.other_comment
        return {
          scrap: scrapVal,
          qty: scrap.quantity
        }
      })

      // this.store.dispatch({
      //   type: SET_BATCH_LIST_VIEW,
      //   payload: { switchingBatch: true }
      // });

      // const openBatches = this.wizBatches.filter(batch => batch.batchStatus === OPEN);
      const openBatches = this.wizBatches.filter(batch => batch.batchStatus === OPEN || batch.batchStatus === LOCKED || batch.batchStatus === SEALED);

      if (!scrapCodes || !scrapCodes.length) {
        const updatedBatch = Object.assign({}, this.currentBatch, {
          designatedScrap: true
        });
        this.store.dispatch({
          type: SET_BATCH_LIST_VIEW,
          payload: { loading: true }
        });
        this.batchService.updateBatch(updatedBatch);

        if (!openBatches.length) {
          this.store.dispatch({
            type: SET_BATCH_LIST_VIEW,
            payload: { cuttingView: NO_BATCHES }
          });
        } else {
          console.log("CUTTING VIEW QTY?")
          this.store.dispatch({
            type: SET_BATCH_LIST_VIEW,
            payload: { 
              cuttingView : QTY,
              loading: true 
            }
          });
        }
      } else {
        const scrap: any = {
          batchId : `${this.currentBatch.id}`,
          category: OA,
          jobs    : this.currentBatch.jobHistory,
          user    : this.authService.getCurrentUser(),
          material: this.currentBatch.material,
          productSubAssembly: this.currentBatch.subAssembly,
          scrapCodes,
          totalQty: this.currentBatch.totalQty
        };

        this.scrapService.createScrap(scrap);

        if (!openBatches.length) {
          this.store.dispatch({
            type: SET_BATCH_LIST_VIEW,
            payload: { cuttingView: NO_BATCHES }
          });
        } else {
          this.store.dispatch({
            type: SET_BATCH_LIST_VIEW,
            payload: { 
              cuttingView : QTY,
              loading: true 
            }
          });
        }
      }
      this.scrapForm.markAsPristine();
      this.scrapForm.controls.scrapReasons.reset();
      this.scrapForm.setControl('scrapReasons', this.fb.array([]));
      this.addScrapReason()
    }
  }

  getJobsInBatch(batch: Batch, type = null, caculateTotal = false): Job[] {
    if (!batch || !batch.numberOfJobs) return [];

    this.curBatchQtyLeft = 0;
    if(type === 'curBatch' && caculateTotal) {
      this.curBatchTotalQty = 0;
    } else {
      this.nextBatchTotalQty = 0;
    }

    this.jobList
      .take(1)
      .subscribe(jobs => {
        const jobIDs = [];
        batch.jobs.forEach(batchJob => {
          batchJob.jobsList.forEach(job => {
            jobIDs.push(job.jobId);
          })
        });
    
        if (!jobIDs.length) return [];
    
        const currentJobs = [];
        jobIDs.forEach(id => {
          const job = jobs.find(job => job.id === id);
          if(job){
            currentJobs.push(job);
            if(type === 'curBatch') {
              this.curBatchQtyLeft += !!this.currentBatch.compKey.match(/_R$/) ? job.numPages : job.docCopies;
              // console.log("this.curBatchQtyLeft : ", this.curBatchQtyLeft);
              if(caculateTotal) {
                this.curBatchTotalQty += !!this.currentBatch.compKey.match(/_R$/) ? job.numPages : job.docCopies;
              } 
            } else {
              this.nextBatchTotalQty += !!this.nextBatch.compKey.match(/_R$/) ? job.numPages : job.docCopies;
            }
          }
        });
        // console.log(currentJobs)
        if(type === 'curBatch') {
          this.currentBatchJobs = currentJobs;
        } else {
          this.nextBatchJobs = currentJobs;
        }
      });
    
  }

  openOnHoldModal(template: TemplateRef<any>, cuttingView: string): void {
      this.dieList
      .take(1)
      .subscribe( (dies) => {
        this.currentDie = dies.find(die => die.id === this.currentBatch.die);
      })
      
      this.holdReason = cuttingView === 'die' ? DIENOTAVAILABLE : MATERIALNOTAVAILABLE;
      this.onHoldModalRef = this.modalService.show(template, {
        animated: false
      });
  }

  openOnHoldSingleJobModal(template: TemplateRef<any>): void {
    this.onHoldModalSingleJobRef = this.modalService.show(template, {
      animated: false
    });
  }

  holdJob(): void {
    if(this.holdReason === DIENOTAVAILABLE){
      this.store.dispatch({
        type: SET_BATCH_LIST_VIEW,
        payload: { 
          dieLoading: true 
        }
      });
      const updatedDie = Object.assign({}, this.currentDie, {
        isAvailable: false,
        comment: this.comment+` User:${this.authService.getCurrentUser()}`
      });
      this.batchService.updateDie(updatedDie);
    } else {
      this.store.dispatch({
        type: SET_BATCH_LIST_VIEW,
        payload: { 
          materialLoading: true 
        }
      });
      const updatedProduct = Object.assign({}, this.currentJob.product, {
        isActive: false,
        comment: this.comment+` User:${this.authService.getCurrentUser()}`
      });

      this.productService.updateProduct(updatedProduct);
    }

    this.holdReason = "";
    !!this.onHoldModalRef && this.onHoldModalRef.hide();
  }
  
  holdSingleJob() : void {
    this.orderService.setJobStatus(
      this.currentJob, 
      HOLD, 
      this.translate.instant(this.singleJobHoldReason),
      undefined,
      this.otherReason
    );

    this.store.dispatch({
      type: SET_BATCH_LIST_VIEW,
      payload: { 
        cuttingView : QTY,
        loading: true 
      }
    });

    !!this.onHoldModalSingleJobRef && this.onHoldModalSingleJobRef.hide();
  }

  pressureStepValidator(control: FormControl | string): any {
    const pressure = control instanceof FormControl
      ? control.value
      : control;
    
    if (pressure % 0.5 !== 0) {
      return { pressureStepInvalid: 'Pressure needs to be a multiple of 0.5' };
    }

    return null;
  }

  resetDiePressure(): void {
    this.diePressureForm.patchValue({
      diePressureValue: this.initialPressureValue
    });
  }

  updateDiePressure(): void {
    if (this.diePressureForm.valid) {
      const { value: { diePressureValue } } = this.diePressureForm;

      this.diePressureForm.markAsPristine();
  
      this.store.dispatch({
        type: SET_BATCH_LIST_VIEW,
        payload: { diePressureUpdating: true }
      });

      this.batchService.updateDiePressureValue(
        this.currentDie,
        diePressureValue,
        this.currentBatch,
        this.currentJob.orderId,
        this.currentJob.id
      );
    }
  }

  viewBatchDetails(status: string, id: string): void {
    this.router.navigate([id], { relativeTo: this.route });
  }

  viewJobDetails(status: string, id: string): void {
    this.router.navigate(['oa/dashboard/jobs', status, id]);
  }

  addScrapReason() : void {
    (<FormArray>this.scrapForm.get('scrapReasons')).push(this.fb.group({
      reason  : [null, [Validators.required]],
      quantity: [0,[Validators.required, Validators.min(1), Validators.max(999)]],
      other_comment : [null]
    }));
  }

  removeScrapReason(scrapEntry, removeIndex) : void {
    (<FormArray>this.scrapForm.get('scrapReasons')).removeAt(removeIndex)
    console.log((<FormArray>this.scrapForm.get('scrapReasons')));

  }
  
  trackByFn(index, item) {
    return index;
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/wizard-modal/wizard-modal.component.ts